<template>
  <div
    ref="navButton"
    class="nav-button-flex"
    @mouseup="showMenu"
    @mouseover="showOverlay"
    @mouseout="hideOverlay"
  >
    <div class="nav-button-holder">
      <div
        ref="marker"
        class="nav-marker"
      />
      <div class="nav-flex">
        <div class="nav-button">
          <div class="nav-image">
            <v-img
              :src="require('@/assets/svg/menu/' + option.name + '.svg')"
              class="menu-icon"
            />
          </div>
        </div>
      </div>
      <div
        ref="overlay"
        class="sub-menu-overlay"
      >
        <div class="spacer" />
        <div
          ref="label"
          class="label"
        >
          {{ option.name || '' }}
        </div>
        <div class="spacer" />
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { useMenuStore } from '@/store/MenuStore';
import { storeToRefs } from 'pinia/dist/pinia';

export default {
  name: 'NavButton',
  props: [
    'option',
    'type'
  ],
  setup () {
    const menuStore = useMenuStore();
    const { getSelectedNavButton, getSubMenuOpen } = storeToRefs(useMenuStore());
    return {
      menuStore, getSelectedNavButton, getSubMenuOpen
    };
  },
  watch: {
    getSelectedNavButton (to) {
      gsap.to(this.$refs.marker, {
        width: (to === this) ? 5 + 'px' : 0 + 'px',
        ease: 'power3.inOut',
        duration: .3
      });
    },
    getSubMenuOpen (to) {
      if (!to) {
        gsap.to(this.$refs.marker, {
          width: 0,
          ease: 'power3.inOut',
          duration: .3
        });
      }
    },
    $route (to) {
      if (to.path.includes(this.option.name.toLowerCase())) {
        this.select();
      } else {
        this.deselect();
      }
    }
  },
  mounted () {
    gsap.set(this.$refs.overlay, {
      width: 0 + 'px',
      autoAlpha: 0
    });
    gsap.set(this.$refs.label, {
      autoAlpha: 0
    });
  },
  methods: {
    showMenu (e) {
      if (this.$props.type === 'nelson') {
        this.$router.push('/');
        return;
      }
      if (this.$props.option.name === 'rmt') {
        this.$router.push('/rmt');
        return;
      }
      this.hideOverlay(e);
      this.menuStore.setSelectedNavButton(this);
    },
    showOverlay () {
      if (this.$props.type === 'nelson') {
        return;
      }
      gsap.killTweensOf(this.$refs.overlay);
      gsap.killTweensOf(this.$refs.label);
      gsap.to(this.$refs.overlay, {
        transformOrigin: 'top left',
        width: 'auto',
        ease: 'power3.inOut',
        autoAlpha: 1,
        duration: .4
      });
      gsap.to(this.$refs.label, {
        autoAlpha: 1,
        duration: .2,
        delay: .1
      });
    },
    hideOverlay () {
      gsap.killTweensOf(this.$refs.overlay);
      gsap.killTweensOf(this.$refs.label);
      if (this.$props.type === 'nelson') { return; }
      gsap.to(this.$refs.overlay, {
        transformOrigin: 'top left',
        width: 0 + 'px',
        ease: 'power4.inOut',
        autoAlpha: 0,
        duration: .4
      });
      gsap.to(this.$refs.label, {
        autoAlpha: 0,
        duration: .4
      });
    },
    select () {
      gsap.to(this.$refs.navButton, {
        backgroundColor: '#f1f1f1'
      });
    },
    deselect () {
      gsap.to(this.$refs.navButton, {
        backgroundColor: '#ffffff'
      });
    }
  }
};
</script>

<style>
:root {
  --nav-height: 55px;
}
</style>

<style scoped>
.nav-button-flex {
  position: relative;
  width: var(--nav-height);
  height: var(--nav-height);
  cursor: pointer;
  background-color: #ffffff;
}
.nav-marker {
  height: 100%;
  background-color: #9c9c9c;
  width: 0px;
}
.nav-button-holder {
  position: absolute;
  width: var(--nav-height);
  height: var(--nav-height);
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-button {
  position: absolute;
  width: 32px;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.nav-image {
  pointer-events: none;
  width: 32px;
  aspect-ratio: 1/1;
}
.sub-menu-overlay {
  height: 80%;
  position: absolute;
  left: 50px;
  background-color: var(--nelson-green);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: .82em;
  font-weight: bold;
  letter-spacing: .03em;
  overflow: hidden;
}
.spacer {
  width: 20px;
  height: inherit;
  background-color: transparent;
}
.label {
  text-transform: capitalize;
}
</style>